import { render, staticRenderFns } from "./TeamPendentInvitations.vue?vue&type=template&id=0d6ebb92&scoped=true"
import script from "./TeamPendentInvitations.vue?vue&type=script&lang=ts"
export * from "./TeamPendentInvitations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6ebb92",
  null
  
)

export default component.exports